import backendUrls from "../utils/BackendUrls";
import { CALL_API } from "../utils/HTTP";

const PopupService = {
  getActive: async function () {
    return await CALL_API(
      "GET",
      backendUrls.POPUP.ACTIVE,
      null,
      false,
      false
    );
  },
};

export default PopupService;
